import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'js-cookie';
import API_BASE_URL from '../../ApiConfig/ApiConfig';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faLock, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';


function Login() {
  const [userid, setUserid] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();


  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };


  const scheduleLogout = () => {
    // Set expiration time to 1 hour from now
    const oneHour = 1 * 60 * 60 * 1000; // 1 hour in milliseconds
  
    // Schedule logout in 1 hour
    setTimeout(() => {
      logoutUser();
    }, oneHour);
  };
  
  


  // Logout function
  const logoutUser = () => {
    Cookies.remove('token'); // Remove token from cookies
    navigate('/'); // Redirect to login page
  };


  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); // Reset error before making request


    try {
      // API call to login endpoint
      const response = await axios.post(`${API_BASE_URL}/api/users/login`, { email: userid, password });


      // Assuming the response contains a token on successful login
      const token = response.data.token;
      Cookies.set('token', token, { expires: 7, secure: true, sameSite: 'Strict' });
 
      // Schedule automatic logout (5 minutes)
      scheduleLogout();


      // Redirect to customer dashboard
      navigate('/customer_dashboard');
    } catch (err) {
      // Handle various types of errors
      if (err.response) {
        // Server responded with an error
        console.error('Error Response:', err.response.data);
        setError(err.response.data.message || 'Invalid User ID or Password');
      } else if (err.request) {
        // No response received from the server
        console.error('No Response:', err.request);
        setError('No response from the server. Please try again later.');
      } else {
        // Other errors (like network issues)
        console.error('Error:', err.message);
        setError('An error occurred. Please try again.');
      }
    }
  };


  return (
    <>
   <div className="flex items-center justify-center min-h-screen bg-[#FAF9FF] flex-col px-4 md:px-0">
  <div className="flex flex-col md:flex-row bg-white shadow-lg overflow-hidden w-full md:w-10/12 max-w-4xl rounded-2xl">
    
    {/* Left Section with Image - Hidden on mobile */}
    <div className="hidden md:flex justify-center items-center w-full md:w-1/2 bg-white overflow-hidden rounded-t-2xl md:rounded-l-2xl">
      <img src="/auth-page-images/Layer_1 Sn 2.svg" alt="Illustration" className="w-full h-full object-cover" />
    </div>


    {/* Right Section with Form */}
    <div className="w-full md:w-1/2 p-6 md:p-8 mt-6 md:mt-8 md:mt-0 rounded-b-2xl md:rounded-r-2xl">
      <img src="/auth-page-images/securent 1.svg" alt="SecureNet Logo" className="mx-auto mb-6 h-8" />
      {error && <p className="text-red-500 text-center mb-4">{error}</p>} {/* Display error message */}


      <form onSubmit={handleSubmit} className="pt-4">
        <div className="mb-6 relative">
          <input
            type="text"
            id="userid"
            className="w-full p-2 pl-10 bg-[#E2EDFF80] rounded-md focus:outline-none focus:ring-2 focus:ring-[#1C50A3] text-lg font-semibold text-[#1C50A3] placeholder:text-[#1C50A3]"
            value={userid}
            onChange={(e) => setUserid(e.target.value)}
            placeholder="Username"
            autoComplete="username"
          />
          <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-[#1C50A3]">
            <FontAwesomeIcon icon={faUser} />
          </span>
        </div>


        <div className="mb-4 relative">
          <input
            type={showPassword ? 'text' : 'password'}
            id="password"
            className="w-full p-2 pl-10 bg-[#E2EDFF80] rounded-md focus:outline-none focus:ring-2 focus:ring-[#1C50A3] text-lg font-semibold text-[#1C50A3] placeholder:text-[#1C50A3]"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            autoComplete="current-password"
          />
          <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-[#1C50A3]">
            <FontAwesomeIcon icon={faLock} />
          </span>
          <span
            className="absolute inset-y-0 right-0 pr-4 mt-1 flex items-center cursor-pointer text-[#1C50A3]"
            onClick={togglePasswordVisibility}
          >
            <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
          </span>
        </div>


        <div className="mb-6 text-right">
          <Link to="/forgot-password" className="text-[#1C50A3] hover:underline text-sm font-semibold">
            Forgot Password?
          </Link>
        </div>


        <button
          type="submit"
          className="w-full bg-[#1C50A3] text-white p-2 rounded-lg transition duration-200 text-lg font-bold"
        >
          Submit
        </button>
      </form>


      <div className="mt-4 text-center">
        <span className="text-gray-600 text-sm">Don't have an account?</span>
        <Link to="/register" className="text-[#1C50A3] font-bold ml-2 hover:underline">
          Register
        </Link>
      </div>
    </div>
  </div>


  <footer className="mt-4 text-center text-gray-600 text-sm px-4">
  <p>© 2025 Securenet India. All Rights Reserved.</p>
  <p>
    Developed by{" "}
    <a
      href="https://creativestudio24.in"
      target="_blank"
      rel="noopener noreferrer"
      className="hover:underline"
    >
      Creative Studio 24
    </a>
  </p>
</footer>


</div>
 
</>
  );
}


export default Login;
